import {ChangeDetectorRef, Directive, HostBinding, HostListener} from '@angular/core';
import {ErrorNotifierService} from 'app/core/error-handler/error-notifier.service';
import {DisableDemoService} from 'app/core/services/disable-demo.service';

@Directive({
    selector: '[finishDemo]',
})
export class FinishDemoDirective {
    @HostBinding('class.block-loading') loading = false;

    constructor(
        private demo: DisableDemoService,
        private errorNotifier: ErrorNotifierService,
        private cd: ChangeDetectorRef
    ) {}

    @HostListener('click', ['$event']) onClickFinishDemo(event: MouseEvent) {
        event.stopPropagation();
        event.preventDefault();
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.cd.markForCheck();
        this.demo.finish().subscribe(
            () => this.refreshPage(),
            e => {
                this.errorNotifier.notifyUser(e);
                this.loading = false;
                this.cd.markForCheck();
            }
        );
    }

    refreshPage() {
        location.href = location.href;
    }
}
